// packages/constants/src/inputs/phone.ts
export const PHONE_MAX_COUNT = 2;
export const PHONE_NUMBER_MAX_LENGTH = 15;


